export const SUCCESS = 0
export const FAILED = 1
export const UNAUTHORIZED = 2
export const LICENSE_ACCEPTANCE_REQUIRED = 3 // User license agreement acceptance required.
export const PASSWORD_CHANGE_REQUIRED = 4
export const UNLICENSED = 5 // User isn't currently licensed for the requested operation.
export const PENDING = 1024 // Asynchronous request still pending on server-side (not currently supported).
